import Axios from "axios";

const axiosMeet = Axios.create({
    baseURL: process.env.NEXT_PUBLIC_TACNIQUE_ASYNC_MEET_BACKEND_URL,
});

export default axiosMeet;